import React, { useContext } from 'react';

let Context = React.createContext<boolean>(false);

export let SkeletonProvider = Context.Provider;

export let useSkeleton = () => (useContext(Context) as unknown) as boolean;
